export const transformSidesArrayToString = (sidesArray) => {
  if (sidesArray?.length === 2 && sidesArray[0] === "L") {
    sidesArray.reverse();
  }
  return sidesArray;
};
